import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { TNKAuthCustomerComponent } from './auth-customer.component';
import { AuthCustomerService } from './auth-customer.service';
import { AnalyticsService } from '../../services/analytics.service';
import { ApiRequestService } from '../../services/api-request.service';
export class TNKAuthCustomerModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    TNKUtilitiesModule,
    HttpClientModule,
    RouterModule,
  ],
  declarations: [TNKAuthCustomerComponent],
  providers: [
    ApiConstant,
    AuthCustomerService,
    AnalyticsService,
    ApiRequestService,
  ],
  exports: [TNKAuthCustomerComponent],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKAuthCustomerModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKAuthCustomerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKAuthCustomerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
